import { render } from "./ResetPassword.vue?vue&type=template&id=4fa4a2de"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/views/ResetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fa4a2de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fa4a2de', __exports__)) {
    api.reload('4fa4a2de', __exports__)
  }
  
  module.hot.accept("./ResetPassword.vue?vue&type=template&id=4fa4a2de", () => {
    api.rerender('4fa4a2de', render)
  })

}


export default __exports__